module.exports = __webpack_public_path__ + "static/media/logo-white.6675ad22.svg";